import {
  captureFatalException,
  captureException,
  captureWarning,
  captureEvent,
} from '@src/quince-site-common/src/utils/sentryUtil'

export { captureFatalException, captureException, captureWarning, captureEvent }
